<template>
  <div class="exp-header" :style="`background-image: url(${expHeaderBg})`">
    <div class="exp-header-tabs">
      <i class="el-icon-arrow-left" @click="$router.push('/simulation')"></i>
      <div
        class="tab"
        :class="{ 'tab-active': tab.id == id }"
        v-for="tab in tabs"
        :key="tab.title"
        @click="handleTab(tab)"
      >
        {{ $t(tab.title) }}
      </div>
    </div>
    <LanguageExperimentInfo />
  </div>
</template>

<script>
import { menuList, articles, articleInfo } from '@/api/introduction/index'
import { formatLan } from '@/utils/lanFormat'
import LanguageExperimentInfo from '@/components/experimentation/languageLayout/language-experiment-info'
export default {
  name: 'exp-header',
  components: { LanguageExperimentInfo },
  props: [],
  data() {
    return {
      tabs: [],
      expHeaderBg: this.publicData.serverUrl + 'images/banenr.jpg',
      expId: null,
    }
  },
  watch: {},
  computed: {
    id() {
      return parseInt(this.$route.query.id)
    },
  },
  created() {},
  mounted() {
    this.expId = window.localStorage.getItem('expId')
    this.getTabs()
  },
  methods: {
    getTabs() {
      menuList({ course_id: this.expId }).then((res) => {
        const { data } = res
        let tabs = [
          {
            id: this.expId,
            title: 'lang.external.fzsy.content.header.项目首页',
            path: '/simulation/experiment',
          },
        ]
        data.forEach((v) => {
          v.path = '/simulation/describe'
          v.title = formatLan(v.title)
          tabs.push(v)
        })
        this.tabs = tabs
        tabs.forEach((v) => {
          if (v.id === this.id) {
            articles({ menu_id: v.id }).then((res) => {
              const { data } = res.data
              if (data.length) {
                this.$store.commit('experiment/SET_DESCRIBE_CONTENT', data[0])
              }
            })
          }
        })
      })
    },
    handleTab(val) {
      if (val.path + `?id=${val.id}` === this.$route.fullPath) return
      if (
        this.$t(val.title) ===
        this.$t('lang.external.fzsy.content.header.项目首页')
      ) {
        this.$router.push({ path: val.path, query: { id: val.id } })
      } else {
        articles({ menu_id: val.id }).then((res) => {
          const { data } = res.data
          if (data.length) {
            this.$store.commit('experiment/SET_DESCRIBE_CONTENT', data[0])
            this.$router.push({ path: val.path, query: { id: val.id } })
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.exp-header {
  width: 100%;
  height: 40vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: white;
  text-align: center;
  &-tabs {
    position: relative;
    display: flex;
    justify-content: center;
    .tab {
      color: white;
      padding: 1rem;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        font-weight: bold;
        color: #0c5893;
      }
    }
    .tab-active {
      font-weight: bold;
      color: #0c5893;
    }
    i {
      position: absolute;
      top: 50%;
      left: 24px;
      transform: translateY(-50%);
      cursor: pointer;
    }
  }
}
</style>